import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AddNewClientWizard from "../components/AddNewClientWizard/AddNewClientWizard";
import {
  dashboard as dashboardRoutes,
  auth as authRoutes,
  nav as navRoutes,
  buyFlow as buyFlowRoutes,
  planCompare as planCompareRoutes,
  userProfile,
  settings,
  adminSettings,
  glossary,
  adminPayments,
  advisorPayments,
  adminCustomizations,
  advisorCustomizations,
} from "./index";

import DashboardLayout from "../layouts/Dashboard/Dashboard";
import AuthLayout from "../layouts/Auth/Auth";
import Navigation from "../layouts/Navigation/Navigation";
import Page404 from "../pages/auth/Page404";
import UnSavedDataPrompt from "../components/Modals/UnsavedDataPrompt/UnSavedDataPrompt";

import { connect } from "react-redux";
import SessionTimeoutModal from "../components/Modals/SessionTimeout/SessionTimeoutModal";
import SSOModal from "../components/Modals/SSOModal/SSOModal";

const childRoutes = (Layout, routes) =>
  routes.map(({ children, path, component: Component }, index) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component }, index) => (
        <Route
          key={index}
          path={path}
          exact
          render={(props) => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  );

const addChildRoutes = (root, top, side, useHeader) => {
  let reactRouteList = [];

  if (!root.children) return [];

  root.children.forEach((gChild, index) => {
    reactRouteList.push(
      <Route
        key={index}
        path={gChild.path}
        exact
        render={(props) => (
          <DashboardLayout>
            <Navigation
              topNavItems={top}
              navItems={side}
              useHeader={useHeader}
              minimizeHeader={gChild.minimizeHeader}
            >
              <gChild.component {...props} />
            </Navigation>
          </DashboardLayout>
        )}
      />
    );

    reactRouteList = reactRouteList.concat(
      addChildRoutes(gChild, top, side, useHeader)
    );
  });

  return reactRouteList;
};

const childRoutesNavigation = (routes, useHeader) => {
  let reactRouteList = [];

  routes.forEach((r) => {
    let top = r.children;

    reactRouteList.push(
      <Route
        key={0}
        path={r.path}
        exact
        render={(props) => (
          <DashboardLayout>
            <Navigation topNavItems={top} navItems={[]} useHeader={useHeader}>
              <r.component {...props} />
            </Navigation>
          </DashboardLayout>
        )}
      />
    );

    top.forEach((child) => {
      let side = child.children;

      reactRouteList.push(
        <Route
          key={0}
          path={child.path}
          exact
          render={(props) => (
            <DashboardLayout>
              <Navigation
                topNavItems={top}
                navItems={side}
                useHeader={useHeader}
                minimizeHeader={r.minimizeHeader}
              >
                <child.component {...props} />
              </Navigation>
            </DashboardLayout>
          )}
        />
      );

      reactRouteList = reactRouteList.concat(
        addChildRoutes(child, top, side, useHeader)
      );
    });
  });
  return reactRouteList;
};

const BlankSlateLayout = (props) => {
  return <div className={"vestevo-page"}>{props.children}</div>;
};

const Routes = (props) => {
  return (
    <Router>
      <Switch>
        {childRoutes(DashboardLayout, dashboardRoutes)}
        {childRoutes(DashboardLayout, glossary)}
        {childRoutes(BlankSlateLayout, authRoutes)}
        {childRoutes(BlankSlateLayout, buyFlowRoutes)}
        {childRoutes(BlankSlateLayout, planCompareRoutes)}
        {childRoutesNavigation(userProfile, false)}
        {childRoutesNavigation(settings, false)}
        {childRoutesNavigation(adminSettings, false)}
        {childRoutesNavigation(navRoutes, true)}
        {childRoutesNavigation(adminPayments, false)}
        {childRoutesNavigation(advisorPayments, false)}
        {childRoutesNavigation(adminCustomizations, false)}
        {childRoutesNavigation(advisorCustomizations, false)}
        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
      <UnSavedDataPrompt when={props.hasUnsavedContent} />
      <SessionTimeoutModal />
      <SSOModal />
      {props.uxState.getIn(["showClientWizard"]) && <AddNewClientWizard />}
    </Router>
  );
};

const mapStateToProps = (state) => {
  return {
    uxState: state.uxStateReducer,
    hasUnsavedContent: state.uxStateReducer.get("hasUnsavedContent"),
  };
};

export default connect(mapStateToProps)(Routes);
